// extracted by mini-css-extract-plugin
export default {"container":"Lh0fc","inner":"o0DuP","headers":"bkcXd","data":"WuVe1"};